import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-scroll-to-top',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scroll-to-top.html',
  styleUrl: './scroll-to-top.scss'
})
export class ScrollToTopComponent implements OnInit {
  isVisible = false;
  isExiting = false;
  private exitTimeout: any;

  ngOnInit(): void {
    // Component initialization
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const shouldBeVisible = window.pageYOffset > 300;
    
    if (shouldBeVisible && !this.isVisible && !this.isExiting) {
      // Button is becoming visible
      this.isVisible = true;
      this.isExiting = false;
    } else if (!shouldBeVisible && this.isVisible && !this.isExiting) {
      // Button is becoming hidden - start exit animation
      this.isExiting = true;
      this.exitTimeout = setTimeout(() => {
        this.isVisible = false;
        this.isExiting = false;
      }, 400); // Match animation duration
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  ngOnDestroy(): void {
    if (this.exitTimeout) {
      clearTimeout(this.exitTimeout);
    }
  }
}
